// Who may do what with ONE visit, as the web app draws it.
//
// The server decides all of this (15 Sep 2026, R3 / R5 — see
// Backend/api/controllers/appointmentController.js, appointmentViewer and
// friends); these helpers only stop the UI from offering a button the server
// is going to refuse:
//
//   GET /appointment/:id          the visit's own doctor, that hospital's admin,
//                                 staff holding appointments.view. A doctor
//                                 opening a COLLEAGUE's visit gets 403.
//   audio / image upload, delete  the visit's own doctor — never the admin
//                                 (30 Sep 2026: the server answers the admin
//                                 403 ADMIN_NO_CLINICAL_WRITE on every
//                                 clinical write of a visit), never staff,
//                                 never a colleague.
//
// A doctor's login `ID` (localStorage, written at login) is their business
// doctorId, the same value MedicalHistory already sends as ?doctorId=.

const sameId = (a, b) => a !== undefined && a !== null && a !== '' && String(a) === String(b);

/**
 * Is this a visit another doctor ran, seen by a doctor? Only a doctor has
 * "colleagues" here: an admin and staff read every visit of their hospital.
 * A row with no doctorId is not called a colleague's — the server answers it.
 */
export const isColleagueVisit = (visit, role, myId) =>
    role === 'doctor' && !!visit?.doctorId && !!myId && !sameId(visit.doctorId, myId);

/** May this login upload or delete a visit's recordings and images? */
export const canManageVisitMedia = (visit, role, myId) => {
    if (!visit) return false;
    return role === 'doctor' && !!myId && sameId(visit.doctorId, myId);
};
